import {
  SearchBar,
  Pagination,
  DateRangePicker,
  Icon,
  Dropdown,
} from "@components/index";
import BookingListRender from "./components/BookingListRender";
import BookingDetailsModal from "./components/BookingDetailsModal";
import { useBookingsData, searchOptions, POLICY_STATUS } from "./bookingsData";
import "./index.scss";

const Bookings = () => {
  const {
    bookings: paginatedBookings,
    allBookings: filteredBookings,
    loading,
    error,
    searchValue,
    handleSearch,
    fromDate,
    toDate,
    handleDateChange,
    selectedBooking,
    isModalOpen,
    handleViewBooking,
    handleCloseModal,
    handleDownloadMIS,
    currentPage,
    handlePageChange,
    selectedStatusFilter,
    handleStatusFilterChange,
    handleClearFilters,
  } = useBookingsData();

  // if (loading) {
  //   return <CircularLoader />;
  // }

  return (
    <div className="bookings-page">
      <div
        className="bookings-page__header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          <h1 className="bookings-page__title">All Policies</h1>
        </div>
        <button
          className="bookings-page__download-btn"
          onClick={handleDownloadMIS}
        >
          <Icon
            iconName="downlaodIcon"
            height={16}
            width={16}
            className="download-icon"
          />
          Download MIS Data
        </button>
      </div>

      <div className="bookings-page_filters">
        <div className="bookings-page_filters-section">
          <SearchBar
            searchOptions={searchOptions}
            onSearch={handleSearch}
            showSearchButton={false}
            initialValue={searchValue}
          />

          <Dropdown
            label="Policy Status"
            value={selectedStatusFilter}
            onChange={handleStatusFilterChange}
            options={POLICY_STATUS}
            className="bookings-page_status-dropdown"
          />

          <DateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onChange={handleDateChange}
            className="booking_date-range-picker"
            allowFutureDates
          />
        </div>

        <button
          className="bookings-page_clear-btn"
          onClick={handleClearFilters}
        >
          Reset Filters
        </button>
      </div>

      {/* Bookings List */}
      <BookingListRender
        bookings={paginatedBookings}
        loading={loading}
        error={error}
        onViewBooking={handleViewBooking}
        onClearFilters={handleClearFilters}
      />

      {/* Pagination */}
      <Pagination
        data={filteredBookings}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        itemsPerPage={10}
        showInfo={true}
        showFirstButton={true}
        showLastButton={true}
      />

      {/* Booking Details Modal */}
      <BookingDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        booking={selectedBooking}
      />
    </div>
  );
};

export default Bookings;
